module.exports = __webpack_public_path__ + "static/media/pra-vote.5dc11284.png";